function currentHeaderOffset() {
  const nav = document.querySelector('header[data-testid="main-nav"]');
  const banner = document.querySelector('[data-testid="event-banner"]');
  const nh = nav ? nav.offsetHeight : 92;
  const bh = banner ? banner.offsetHeight : 0;
  return -(nh + bh + 4);
}

export function scrollToId(target) {
  const el = document.querySelector(target);
  if (!el) return;
  const offset = currentHeaderOffset();
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset });
  } else {
    const y = el.getBoundingClientRect().top + window.scrollY + offset;
    window.scrollTo({ top: y, behavior: "smooth" });
  }
}
